import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_start",
  "use": "icon-video_start-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol viewBox=\"0 0 30 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-video_start\">\n<path d=\"M22.5 13.2867C24.5 14.4414 24.5 17.3281 22.5 18.4828L13.5 23.679C11.5 24.8337 9 23.3903 9 21.0809L9 10.6886C9 8.37921 11.5 6.93584 13.5 8.09054L22.5 13.2867Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol